import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MatTable } from '@angular/material/table';

import { Subscription } from 'rxjs';

import { ShipmentService } from '../shipment.service';

import { EnumsService, PortalService } from '@library/core/services';
import { refGroup } from '@library/common/models';

@Component({
   selector: 'shipment-references',
   templateUrl: './references.component.html',
   styleUrls: ['./references.component.scss']
})
export class ReferencesComponent implements OnInit, OnDestroy {

   @ViewChild('reference_table') reference_table: MatTable<any>;

   document = document;

   references: FormArray;
   newRef: FormGroup;

   config;

   shipmentSub: Subscription;

   constructor(
      public shipment: ShipmentService,
      public enums: EnumsService,
      public portal: PortalService,
   ) { }

   ngOnInit() {
      this.shipmentSub = this.shipment.shipmentForm$.subscribe( s => {
         this.references = s.get( 'references' ) as FormArray;
         this.config = this.shipment.configs?.references;

         if ( this.config.minLength ) {
            while ( this.references.length < this.config.minLength ) {
               this.addRef();
            }
         }
      });
   }

   ngOnDestroy() {
      this.shipmentSub.unsubscribe();
   }

   addRef() {
      this.references.push( refGroup() );
      this.reference_table?.renderRows();
   }

   removeRef( id: number ): void {
      this.references.removeAt( id );
      this.reference_table.renderRows();
   }
}
